<template>
  <div id="legal-privacy">
    <v-container v-if="!$store.state.site.whitelabel">
      <v-card class="rounded-xl" elevation="7">
        <v-container>
          <p class="text-h4">
            {{ $store.state.site.name }} Terms of Service, Last updated: 5th of
            October 2021
          </p>
          <p>
            These Terms of Service, which include the
            <router-link to="/legal/privacy">Privacy Policy</router-link>
            , form a legally-binding agreement between
            {{ $store.state.site.name }} (the "we", "us", "our") and you ("you",
            "your", "yourself", "user").
            <br />
            By accessing the {{ $store.state.site.name }} website ("Service",
            "Website", "Site"), you agree that:
          </p>
          <ul>
            <li>
              You are at least 13 years of age and at the minimum age of digital
              consent in your country.
            </li>
            <li>
              If you are the age of majority in your jurisdiction or above, that
              you have read, understood, and accept to be bound by the Terms of
              Service.
            </li>
            <li>
              If you are between 13 and the age of majority in your jurisdiction
              that your parent or legal guardian has reviewed and agrees with
              the Terms of Service.
            </li>
          </ul>
          We have the right to update, replace and modify any part of the Terms
          of Service, we will notify the user on major changes via email, and
          any change via a notification on the Website.
          <p class="text-h5">Your rights to use the Service.</p>
          <p>
            The Service provides a content sharing and hosting platform. Subject
            to your compliance with these Terms, we grant you a limited,
            revocable, non-exclusive, non-transferable, non-sublicensable
            license to use and access the Service. You agree not to, nor attempt
            to (a) use the Service for any purpose other than expressly
            permitted by these Terms; (b) copy, adapt, modify, prepare
            derivative works based upon, distribute, license, sell, transfer,
            attempt to discover any source code, reverse engineer, decompile,
            disassemble, or otherwise exploit the Service or any portion of the
            Service, except as expressly permitted in these Terms; (c) use data
            mining, robots, spiders, or similar data gathering and extraction
            tools on the Service. No licenses or rights are granted to you by
            implication or otherwise under any intellectual property rights
            owned by us, except for the permissions and rights expressly granted
            in these Terms.
            <br />
            We reserves the right to modify or discontinue, temporarily or
            permanently, the Service (or any part thereof) with or without
            notice. We reserves the right to refuse any user access to the
            Services without notice for any reason, including but not limited to
            a violation of the Terms. If you violate these Terms, we reserves
            the right to issue you a warning regarding the violation or
            immediately terminate or suspend any or all Accounts you have
            created using the Service. You agree that we do not need to provide
            you notice before terminating or suspending your Account(s), but it
            may do so.
          </p>
          <p class="text-h5">Your Account</p>
          <p>
            You are responsible for your login credentials and for all activity
            that results from the use of these, as well as any other activity on
            your account ("Account") on the Service. To register, you will be
            prompted to provide a username, email, password and an invite key
            which can be given to you by an existing user of the Service. A
            unique string, used to upload content, ("API Key", "Upload Key",
            "API Upload Key", "Upload API Key") will be generated for you upon
            registration. We reserve the right to reject any username at our
            sole discretion. You are responsible for keeping your login
            credentials secure, and are fully responsible through the activities
            that occur through the use of your credentials. You agree to contact
            us immediately if you believe your login credentials or Account has
            been compromised. This also applies to your API Upload Key, as this
            can be used to upload files to your own Account.
          </p>
          <p class="text-h5">Your Content</p>
          <p>
            Any data, text, images or other files uploaded by you to the Service
            is "Your Content". You warrant that Your Content is original and you
            exclusively own the rights to the content, including the right to
            grant all of the rights set forth in these terms of service without
            the us incurring any liability or obligations from any third-party.
            Your Content is your sole responsibility and we will not take
            responsibility for any materials you upload, post, share or make
            available through other means. By uploading, distributing or
            otherwise using Your Content with the Service, you grant to us a
            perpetual, non-exclusive, transferable, royalty-free worldwide
            license to use, host, distribute and display Your Content solely in
            connection with operating and providing the Service. By using the
            Service, you acknowledge that you may experience content which you
            find offensive. You agree that we will not be liable for any user
            content under any circumstances.
            <br />
            {{ $store.state.site.name }} reserves the right to permanently
            delete Your Content from the Service, either with or without notice,
            and with and without reason. If you believe a user is violating
            these Terms of Service you can contact us at
            <a href="mailto:contact@jays.host">this email address</a>.
          </p>
          <p class="text-h5">Prohibited Activities</p>
          <ul>
            <li>Sell or otherwise transfer their Account.</li>
            <li>
              Trick, defraud, or mislead other users, especially in any attempt
              to learn sensitive account information such as user passwords.
            </li>
            <li>
              Harass, abuse, or harm another person using any information
              obtained from the Service.
            </li>
            <li>
              Circumvent, disable, or otherwise interfere with security-related
              features of the Service. This includes features that
              prevent/restrict the use of any content limits site usage.
            </li>
            <li>
              Upload any materials that actively or passively collects
              information or acts as a transmission mechanism (includes gifs,
              1x1 pixels, web bugs, cookies, spyware, pcms, etc.)
            </li>
            <li>
              Upload illegal content onto the Service (such as child
              pornography.)
            </li>
            <li>
              Interfere, or disrupt the Service's network and/or services.
            </li>
          </ul>
          <p>
            If you believe someone is violating these Terms of Service, please
            contact us at
            <a href="mailto:contact@jays.host">this email address</a>.
          </p>
          <p class="text-h5">Communication</p>
          <p>
            We may notify you on-site or via email about any service changes,
            administrative issues, and general notices such as updates to our
            Terms of Service or Privacy Policy that we think you, the user
            should be aware about.
          </p>
          <p class="text-h5">Severability</p>
          <p>
            In the event that any provision of these Terms of Service is
            determined to be unlawful, void or unenforceable, such provision
            shall nonetheless be enforceable to the fullest extent permitted by
            applicable law and the unenforceable portion shall be deemed to be
            severed from these Terms of Service. Such determination shall not
            affect the validity and enforceability of any other remaining
            provisions, which will remain in full force and effect.
          </p>
          <p class="text-h5">Termination</p>
          <p>
            We may terminate your Account on the Service at any time, with any
            reason via contacting us at
            <a href="mailto:contact@jays.host">this email address</a> and
            requesting that your account deleted. You will be required to
            provide sufficient proof that the Account is yours for the request
            to be successful.
            <br />
            We have the right to terminate and/or ban your Account at any time,
            with or without reason on the Service, we may or may not provide you
            with a notification or reason of the termination. A termination will
            result in loss of access to the account, and all data will be lost.
            A ban will result in loss of access to your account, however your
            data will be retained, a ban is usually for a temporary period of
            time. We will not compensate you for any loss that may occur.
          </p>
          <p class="text-h5">Warranty</p>
          <p>
            TO THE EXTENT PERMITTED BY APPLICABLE LAW, THE SERVICE IS PROVIDED
            "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTY OF ANY KIND, EITHER
            EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NON-INFRINGEMENT. WHILST WE AIM TO PROVIDE A CONSISTENT AND
            CONTINUOUS USER EXPERIENCE, WE CANNOT AND DO NOT GUARANTEE THAT THE
            SERVICE WILL ALWAYS BE ERROR-FREE OR THAT THE SERVICE WILL ALWAYS
            FUNCTION WITHOUT IMPERFECTIONS, DELAYS OR DOWNTIME. YOUR USE OF THE
            SERVICE IS AT YOUR SOLE RISK.
          </p>
          <p class="text-h5">Limitation of Liability</p>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT WILL WE BE
            LIABLE TO YOU OR ANY THIRD PERSON FOR ANY CONSEQUENTIAL, INCIDENTAL,
            SPECIAL, PUNITIVE OR OTHER INDIRECT DAMAGES, INCLUDING ANY LOSS OF
            PROFITS OR DATA, ARISING FROM YOUR USE OF THE SERVICE OR OTHER
            MATERIALS ACCESSIBLE THROUGH THE SERVICE, WHETHER BASED ON CONTRACT,
            TORT, WARRANTY OR OTHERWISE, EVEN IF WE HAVE BEEN ADVISED OF THE
            POSSIBILITY OF THESE DAMAGES. THE LIMITATIONS AND DISCLAIMERS IN
            THESE TERMS DO NOT PURPORT TO LIMIT LIABILITY OR ALTER RIGHTS THAT
            CANNOT BE EXCLUDED UNDER APPLICABLE LAW. SOME JURISDICTIONS DO NOT
            ALLOW THE EXCLUSION OF IMPLIED WARRANTIES OR LIMITATION OF LIABILITY
            FOR INCIDENTAL OR CONSEQUENTIAL DAMAGES, WHICH MEANS THAT SOME OF
            THE ABOVE DISCLAIMERS AND LIMITATIONS MAY NOT APPLY TO YOU. IN THESE
            JURISDICTIONS, OUR LIABILITY WILL BE LIMITED TO THE GREATEST EXTENT
            PERMITTED BY LAW.
          </p>
          <p class="text-h5">Questions?</p>
          <p>
            If you have any questions about our Privacy Policy or Terms of
            Service, please reach us at
            <a href="mailto:contact@jays.host">this email address</a>.
          </p>
        </v-container>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "LegalTerms"
}
</script>

<style scoped></style>
